import { ComponentsOverrides, ComponentsProps, Theme } from "@mui/material";

type MuiCardHeader = {
  defaultProps: ComponentsProps["MuiCardHeader"];
  styleOverrides: ComponentsOverrides<Theme>["MuiCardHeader"];
};

const muiCardHeader: MuiCardHeader = {
  defaultProps: {
    titleTypographyProps: {
      variant: "h6",
    },
  },
  styleOverrides: {
    root: {
      padding: "24px 24px 0",
    },
  },
};

export default muiCardHeader;
